import { REMINDERS_PAUSED_REASONS } from '@shared/core/billing'
import type { RemindersPausedReason } from '@shared/core/billing'
import { ArrowRight } from 'lucide-react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, FormattedText } from 'src/modules/core/components'
import { useUpdatePaymentMethod } from 'src/modules/payment/hooks/use-update-payment-method'
import {
  buildUpgradePlansPath,
  resolveUpgradeSourcePage,
  UPGRADE_TRIGGER_BY_PAUSED_REASON,
} from 'src/modules/payment/utils/upgrade-funnel-navigation'
import type { EventCardPausedActionsProps } from './event-card-paused-actions.interface'
import classes from './event-card-paused-actions.module.scss'

const CAPTION_MESSAGE_IDS: Record<RemindersPausedReason, string> = {
  [REMINDERS_PAUSED_REASONS.quota]: 'event.paused.card.caption',
  [REMINDERS_PAUSED_REASONS.subscriptionEnded]: 'event.paused.card.captionEnded',
  [REMINDERS_PAUSED_REASONS.paymentPaused]: 'event.paused.card.captionPaymentPaused',
}

export function EventCardPausedActions({ reason, freeRemindersLimit, saveDisabled }: EventCardPausedActionsProps) {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()
  const { openUpdateCard, isAvailable, isAwaitingUpdate } = useUpdatePaymentMethod()
  const isPaymentPaused = reason === REMINDERS_PAUSED_REASONS.paymentPaused

  const handleUpgradeClick = () => {
    navigate(
      buildUpgradePlansPath({
        trigger: UPGRADE_TRIGGER_BY_PAUSED_REASON[reason],
        source_element: 'event_card_hover',
        source_page: resolveUpgradeSourcePage(pathname, new URLSearchParams(search)),
      }),
    )
  }

  return (
    <div className={classes.root}>
      <Button
        type="button"
        className={classes.upgradeButton}
        onClick={isPaymentPaused ? openUpdateCard : handleUpgradeClick}
        disabled={isPaymentPaused && !isAvailable}
        isLoading={isPaymentPaused && isAwaitingUpdate}
      >
        <FormattedText id={isPaymentPaused ? 'event.paused.updateCardButton' : 'event.paused.upgradeButton'} />
        <ArrowRight className={classes.arrow} aria-hidden="true" />
      </Button>
      <span className={classes.caption}>
        <FormattedText id={CAPTION_MESSAGE_IDS[reason]} values={{ limit: freeRemindersLimit }} />
      </span>
      <button type="submit" className={classes.saveButton} disabled={saveDisabled}>
        <FormattedText id="event.paused.saveWithoutSending" />
      </button>
    </div>
  )
}
